module.exports = __webpack_public_path__ + "media/9.5306dbb2.wav";